// Centralized services data for search and filtering
export interface Service {
  id: string;
  name: string;
  category: string;
  price: number;
  originalPrice: number;
  rating: number;
  reviewCount: number;
  duration: string;
  description: string;
  provider: string;
  location: string;
  image: string;
  discount?: number;
  popular?: boolean;
  keywords: string[]; // For better search
}

export const allServicesData: Service[] = [
  // Beauty & Health Services
  {
    id: 'facial-treatment',
    name: 'Hydrating Facial Treatment',
    category: 'Beauty',
    price: 899,
    originalPrice: 1299,
    rating: 4.8,
    reviewCount: 2847,
    duration: '60 min',
    description: 'Deep hydrating facial treatment for glowing skin with premium products',
    provider: 'RAPSAPP Beauty',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=300&h=200&fit=crop&crop=face',
    discount: 31,
    popular: true,
    keywords: ['facial', 'beauty', 'skin', 'hydrating', 'glow', 'premium', 'spa']
  },
  {
    id: 'hair-styling',
    name: 'Hair Cut & Styling',
    category: 'Beauty',
    price: 499,
    originalPrice: 699,
    rating: 4.6,
    reviewCount: 1245,
    duration: '45 min',
    description: 'Professional hair cutting and styling service at home',
    provider: 'RAPSAPP Beauty',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=300&h=200&fit=crop',
    discount: 29,
    keywords: ['hair', 'cut', 'style', 'beauty', 'salon', 'professional']
  },
  {
    id: 'manicure-pedicure',
    name: 'Manicure & Pedicure',
    category: 'Beauty',
    price: 599,
    originalPrice: 799,
    rating: 4.8,
    reviewCount: 2103,
    duration: '75 min',
    description: 'Complete nail care service with gel polish options',
    provider: 'RAPSAPP Beauty',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=300&h=200&fit=crop',
    discount: 25,
    popular: true,
    keywords: ['nails', 'manicure', 'pedicure', 'beauty', 'gel', 'polish']
  },
  {
    id: 'massage-therapy',
    name: 'Relaxing Massage Therapy',
    category: 'Wellness',
    price: 1399,
    originalPrice: 1999,
    rating: 4.9,
    reviewCount: 1876,
    duration: '90 min',
    description: 'Therapeutic massage for stress relief and relaxation',
    provider: 'RAPSAPP Wellness',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=300&h=200&fit=crop',
    discount: 30,
    keywords: ['massage', 'therapy', 'wellness', 'stress', 'relaxation', 'therapeutic']
  },

  // Home & Living Services
  {
    id: 'plumbing-repair',
    name: 'Plumbing Repair & Maintenance',
    category: 'Repair',
    price: 649,
    originalPrice: 999,
    rating: 4.7,
    reviewCount: 3621,
    duration: '45 min',
    description: 'Professional plumbing repair and maintenance with warranty',
    provider: 'RAPSAPP Home Services',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=300&h=200&fit=crop',
    discount: 35,
    keywords: ['plumbing', 'repair', 'pipe', 'leak', 'maintenance', 'plumber']
  },
  {
    id: 'electrical-work',
    name: 'Electrical Wiring & Repair',
    category: 'Repair',
    price: 599,
    originalPrice: 799,
    rating: 4.7,
    reviewCount: 2341,
    duration: '90 min',
    description: 'Complete electrical wiring and safety inspection service',
    provider: 'RAPSAPP Home Services',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300&h=200&fit=crop',
    discount: 25,
    popular: true,
    keywords: ['electrical', 'wiring', 'repair', 'electrician', 'safety', 'inspection']
  },
  {
    id: 'carpentry-work',
    name: 'Furniture Assembly & Carpentry',
    category: 'Repair',
    price: 399,
    originalPrice: 599,
    rating: 4.8,
    reviewCount: 1456,
    duration: '60 min',
    description: 'Expert furniture assembly and carpentry services',
    provider: 'RAPSAPP Home Services',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=200&fit=crop',
    discount: 33,
    keywords: ['carpentry', 'furniture', 'assembly', 'wood', 'repair', 'carpenter']
  },
  {
    id: 'painting-service',
    name: 'Wall Painting & Decoration',
    category: 'Repair',
    price: 1299,
    originalPrice: 1599,
    rating: 4.7,
    reviewCount: 876,
    duration: '4 hours',
    description: 'Professional wall painting with premium paints',
    provider: 'RAPSAPP Home Services',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=300&h=200&fit=crop',
    discount: 19,
    keywords: ['painting', 'wall', 'decoration', 'paint', 'color', 'painter']
  },

  // Home Care Services
  {
    id: 'deep-cleaning',
    name: 'Deep Cleaning Services',
    category: 'Home Care',
    price: 1199,
    originalPrice: 1599,
    rating: 4.9,
    reviewCount: 1934,
    duration: '3 hours',
    description: 'Complete home deep cleaning with eco-friendly products',
    provider: 'RAPSAPP Cleaning Co.',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=300&h=200&fit=crop',
    discount: 25,
    popular: true,
    keywords: ['cleaning', 'deep clean', 'home', 'eco-friendly', 'sanitization']
  },
  {
    id: 'bathroom-cleaning',
    name: 'Bathroom Deep Cleaning',
    category: 'Home Care',
    price: 599,
    originalPrice: 899,
    rating: 4.8,
    reviewCount: 1342,
    duration: '90 min',
    description: 'Specialized bathroom cleaning and sanitization',
    provider: 'RAPSAPP Cleaning Co.',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=300&h=200&fit=crop',
    discount: 33,
    keywords: ['bathroom', 'cleaning', 'sanitization', 'hygiene', 'tiles']
  },
  {
    id: 'kitchen-cleaning',
    name: 'Kitchen Deep Cleaning',
    category: 'Home Care',
    price: 899,
    originalPrice: 1199,
    rating: 4.7,
    reviewCount: 987,
    duration: '2 hours',
    description: 'Thorough kitchen cleaning including appliances',
    provider: 'RAPSAPP Cleaning Co.',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=200&fit=crop',
    discount: 25,
    popular: true,
    keywords: ['kitchen', 'cleaning', 'appliances', 'grease', 'deep clean']
  },
  {
    id: 'carpet-cleaning',
    name: 'Carpet & Upholstery Cleaning',
    category: 'Home Care',
    price: 699,
    originalPrice: 999,
    rating: 4.6,
    reviewCount: 756,
    duration: '2 hours',
    description: 'Professional carpet and upholstery steam cleaning',
    provider: 'RAPSAPP Cleaning Co.',
    location: 'Bilaspur, Himachal Pradesh',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop',
    discount: 30,
    keywords: ['carpet', 'upholstery', 'steam cleaning', 'stain removal', 'fabric']
  }
];

// Search function
export const searchServices = (query: string): Service[] => {
  if (!query.trim()) return [];
  
  const lowerQuery = query.toLowerCase();
  return allServicesData.filter(service => 
    service.name.toLowerCase().includes(lowerQuery) ||
    service.description.toLowerCase().includes(lowerQuery) ||
    service.category.toLowerCase().includes(lowerQuery) ||
    service.provider.toLowerCase().includes(lowerQuery) ||
    service.keywords.some(keyword => keyword.toLowerCase().includes(lowerQuery))
  );
};

// Get service suggestions for autocomplete
export const getServiceSuggestions = (query: string): string[] => {
  if (!query.trim()) return [];
  
  const services = searchServices(query);
  const suggestions = new Set<string>();
  
  services.forEach(service => {
    suggestions.add(service.name);
    service.keywords.forEach(keyword => {
      if (keyword.toLowerCase().includes(query.toLowerCase())) {
        suggestions.add(keyword);
      }
    });
  });
  
  return Array.from(suggestions).slice(0, 8); // Limit to 8 suggestions
};

export default allServicesData;
